import { render } from "./AllDoctorsList.vue?vue&type=template&id=318bf224&scoped=true"
import script from "./AllDoctorsList.vue?vue&type=script&lang=js"
export * from "./AllDoctorsList.vue?vue&type=script&lang=js"

import "./AllDoctorsList.vue?vue&type=style&index=0&id=318bf224&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318bf224"]])

export default __exports__